import { Badge, HeaderNavigation } from '@toggle/design-system';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledHeaderNavigation = styled(HeaderNavigation)`
  z-index: var(--z-index-sidebar);
`;

// TODO: remove after new navigation deployed
export const OverrideBodyTag = createGlobalStyle`
  body {
    overflow-y: hidden !important;
  }
`;

const SHADOW_COLOR = '#6592fd';

export const StyledCounterBadge = styled(Badge)<{ $withError: boolean }>`
  position: relative;
  z-index: 1;
  ${Badge.Styled.BadgeNumerical} {
    background-color: ${SHADOW_COLOR};
    box-shadow: ${({ $withError }) =>
      $withError ? 'none' : `0px 0px 5px 1px ${SHADOW_COLOR}`};
  }
`;

export const StyledErrorBadge = styled(Badge)<{ $withCounterBadge: boolean }>`
  position: absolute;
  right: ${({ $withCounterBadge }) => ($withCounterBadge ? '11px' : '0px')};
  ${Badge.Styled.BadgeNumerical} {
    background-color: var(--icon-critical);
  }
`;
